module.exports = __webpack_public_path__ + "static/media/btn-social-instagram.3ba1d15b.png";